import React from 'react';
import { Card, CardContent, CardMedia, Button, Skeleton } from '@mui/material';

function LoadingSkeleton() {
  return (
    <Card>
      <Skeleton variant="rectangular" height={200} />
      <CardContent>
        <Skeleton height={20} width="80%" />
        <Skeleton height={10} width="60%" />
        <Skeleton height={10} width="80%" />
        <Skeleton height={10} width="40%" />
      </CardContent>
      <CardMedia>
        <Skeleton variant="rectangular" height={100} />
      </CardMedia>
      <CardContent>
        <Skeleton height={10} width="80%" />
        <Skeleton height={10} width="60%" />
        <Skeleton height={10} width="80%" />
      </CardContent>
      <CardContent>
        <Button variant="outlined" disabled>
          Loading
        </Button>
        <Button variant="outlined" disabled>
          Loading
        </Button>
      </CardContent>
    </Card>
  );
}

export default LoadingSkeleton;
